module.exports = __webpack_public_path__ + "media/images/metronic/datatables/sort_desc_disabled-558dccb1b37162ab07853d95684d3a9e.png";